function getAgeOptions(min, max) {
  return new Array(max - min + 1).fill(0).map((x, i) => i + min).map(value => ({
    label: String(value),
    value
  }))
}

module.exports = {
  type: 'form',
  id: 'masterdata',
  icon: 'fad fa-file-alt',
  title: {
    de: 'Stammdaten',
    en: 'Master data'
  },
  intro: require('./Construction-Intro.html'),
  outro: '',
  form: [
    {
      id: 'name',
      type: 'text',
      label: {
        de: 'Auftrags-ID',
        en: 'Order ID'
      }
    },
    {
      id: 'description',
      type: 'multi',
      label: {
        de: 'Beschreibung',
        en: 'Description'
      }
    },
    {
      id: 'revenueType',
      defaultValue: 'S',
      type: 'hidden'
    },
    {
      id: 'workflow',
      defaultValue: 'Construction',
      type: 'hidden'
    }
  ]
}
